<template>

  <div class="wrapper">
    <div class="animated fadeIn">
      <b-card header-tag="header" footer-tag="footer">
        <div slot="header">
          <i class="fa fa-align-justify"></i><strong> Manage Banners</strong>
          <div class="card-header-actions">
            <a
              href="#"
              class="card-header-action"
              rel="noreferrer noopener"
              target="_blank"
            >
              <small class="text-muted">filters</small>
            </a>
          </div>
        </div>
        <div class="tablenav top">
          <div class="search-wrapper">
            <input type="text" @keyup.enter="searchById" placeholder="Search by id" v-model="search"/> |
            <button class="ui primary button" @click="searchById">Go</button>
            <button class="ui button" @click="filterReset">Reset</button>

            <a v-if="permission > 1" :href="slugUrl" target="_blank"><button class="ui button">Banner Slugs</button></a>
            <b-button v-if="permission > 2" variant="danger" @click.prevent="purgeRedisCache">Purge Cache</b-button>
            </div>
          <br />
          <div class=" actions">
            <select name="bookmaker" v-model="bookmaker" @change="filterByBookmaker">
              <option value="0">Bookmaker</option>
              <option v-for="bookmaker in bookmakers" :key="bookmaker._id" :value="bookmaker.code">{{ bookmaker.name }}</option>
            </select> |
            <select name="country" v-model="country" @change="filterByCountry">
              <option value="0">Country Code</option>
              <option v-for="country in countries" :key="country._id" :value="country.value">{{ country.name }}</option>
            </select> |
            <select name="size" v-model="size" @change="filterBySize">
              <option value="0">Select size</option>
              <option v-for="size in sizes" :key="size._id" :value="size.sizevalue">{{ size.sizename }}</option>
            </select> |
            <select name="device" v-model="device" @change="filterByDevice">
              <option value="0">Device</option>
              <option value="mobile">Mobile</option>
              <option value="desktop">Desktop</option>
              <option value="tablet">Tablet</option>
            </select> |
            <select v-model="campaign" name="campaign" @change="filterByCampaign">
              <option value="0">Campaign</option>
              <option v-for="campaign in campaigns" :key="campaign._id" :value="campaign.code">{{ campaign.name }}</option>
            </select> |
            <button class="ui button" @click="filterReset">Reset</button>
          </div>
      </div>
       <br />
          <b-pagination-nav
            v-show="paginator.filtered_total > paginator.per_page"
            align="LEFT"
            :link-gen="linkGen"
            :number-of-pages="paginator.last_page"
            @change="getBannersPaginated"
            :no-page-detect="true"
            v-model="paginator.current_page">
          </b-pagination-nav>
        <div class="tablenav-pages one-page">
            <span class="displaying-num">Showing {{ paginator.from || 0 }} to {{ paginator.to || 0 }} from {{ paginator.total }} records!</span>
        </div>
      </b-card>
    </div>
    <div class="animated fadeIn">
      <b-card no-body v-for="banner in banners" :key="banner._id">
        <div slot="header">
          <strong>{{ banner.bannername }}</strong> ({{ banner.size }})
          <!-- <div class="card-header-actions">
            <b-link href="#" class="card-header-action btn-setting">
              <i class="icon-settings"></i>
            </b-link>
            <b-link
              class="card-header-action btn-minimize"
              v-b-toggle.collapse1
            >
              <i class="icon-arrow-up"></i>
            </b-link>
            <b-link
              href="#"
              class="card-header-action btn-close"
              v-on:click="show = !show"
            >
              <i class="icon-close"></i>
            </b-link>
          </div> -->
        </div>
        <b-collapse :id="banner._id" visible>
          <b-card-body>
            <b-form class="banner-edit">
              <div class="form-group">
                <a :href="generateUrl(banner)" target="_blank">{{
                  generateUrl(banner)
                }}</a>
                <p v-if="permission > 1" v-html="checkIfBannerIsMarked(banner)" @click="markHtmlCode(banner)"></p>
              </div>
            <iframe
              :height="bannerHeight(banner)"
              :width="bannerWidth(banner)"
              scrolling="no"
              frameborder="0"
              :src="generateUrl(banner)"
            ></iframe>
              <div slot="footer" class="mt-3">
                <b-button class="mr-2" v-if="permission > 1" type="edit" size="md" variant="warning" @click.prevent="bannerEdit(banner._id)"><i class="fa fa-ban"></i> Edit</b-button>
                <b-button class="mr-2" v-if="permission > 1" variant="dark" type="edit" size="md" @click.prevent="createSimilarBanner(banner._id)"><i class="fa fa-ban"></i> Create Similar</b-button>
                <b-button class="mr-2" v-if="permission > 1" type="submit" size="md" variant="danger"  @click.prevent="deleteBanner(banner._id, banner.image)"><i class="fa fa-trash-o"></i> Delete</b-button>
            </div>
            </b-form>
          </b-card-body>
        </b-collapse>
      </b-card>
      <b-card v-show="paginator.filtered_total > paginator.per_page">
        <b-pagination-nav
          align="LEFT"
          :link-gen="linkGen"
          :number-of-pages="paginator.last_page"
          @change="getBannersPaginated"
          :no-page-detect="true"
          v-model="paginator.current_page"
        ></b-pagination-nav>
        <div class="tablenav-pages one-page">
            <span class="displaying-num">Showing {{ paginator.from || 0 }} to {{ paginator.to || 0 }} from {{ paginator.total }} records!</span>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'breadcrumbs',
  data () {
    return {
      slugUrl: '',
      filters: {},
      banners: '',
      country: 0,
      device: 0,
      bookmaker: 0,
      bookmakers: 0,
      size: 0,
      sizes: '',
      campaigns: 0,
      campaign: 0,
      timeout: 500,
      paginator: {},
      api_url: '',
      search: '',
      mark: `<!--       _
            .__(.)< (:uniqueId | Banner size: :size Device: :device Country: :countryCode Smile)
              ___)
            ~~~~~~~~~~~~~~~~~~-->`
    }
  },
  methods: {
    purgeRedisCache () {
      if (prompt('Are you sure? Type "yes"')) {
        const formData = new FormData()
        formData.append('pattern', '*adonis*')
        this.$http.post(`${this.$api_url}/purgeCache`, formData).then((data) => {
          console.log(data.data)
        }).then((data) => {
          alert('cache purged')
        }).catch((e) => {
          alert('An error ocurred!')
        })
      }
    },
    bannerEdit (id) {
      this.$router.push(`/banners/edit/${id}`)
    },
    createSimilarBanner (id) {
      this.$router.push(`/banners/create/similar/${id}`)
    },
    deleteBanner (id, image) {
      if (prompt("Are you sure? Type 'delete' if yes") === 'delete') {
        this.$http.delete(`${this.$api_url}/banner/delete/${id}`).then((data) => {
          this.$http.post(`${this.$api_url}/mediagallery/remove/uploads/${image}`).then(() => {
            this.getBanners()
          })
        })
      } else {
        alert('Banner not deleted')
      }
    },
    getBannersPaginated (page) {
      this.paginator.current_page = page
      this.getBanners()
    },
    getBanners () {
      this.$http.get(this.requestLinkGen(), this.filters).then(banners => {
        this.banners = banners.data.data
        this.paginator.current_page = banners.data.current_page
        this.paginator.per_page = banners.data.per_page
        this.paginator.last_page = banners.data.last_page === 0 ? 1 : banners.data.last_page
        this.paginator.total = banners.data.total
        this.paginator.filtered_total = banners.data.filtered_total
        this.paginator.from = banners.data.from
        this.paginator.to = banners.data.to
      })
    },
    linkGen (pageNum) {
      const bookmaker = Object.prototype.hasOwnProperty.call(this.filters, 'bookmaker')
        ? `&bookmaker=${this.filters.bookmaker}`
        : ''
      const country = Object.prototype.hasOwnProperty.call(this.filters, 'country')
        ? `&country=${this.filters.country}`
        : ''
      const device = Object.prototype.hasOwnProperty.call(this.filters, 'device')
        ? `&device=${this.filters.device}`
        : ''
      const size = Object.prototype.hasOwnProperty.call(this.filters, 'size')
        ? `&size=${this.filters.size}`
        : ''
      const campaign = Object.prototype.hasOwnProperty.call(this.filters, 'campaign')
        ? `&campaign=${this.filters.campaign}`
        : ''
      const id = Object.prototype.hasOwnProperty.call(this.filters, 'id')
        ? `&id=${this.filters.id}`
        : ''
      const page = `&page=${pageNum}`
      return {
        path: `/banners/manage/?${bookmaker}${country}${device}${size}${campaign}${page}${id}`
      }
    },
    requestLinkGen () {
      const bookmaker = Object.prototype.hasOwnProperty.call(this.filters, 'bookmaker')
        ? `&bookmaker=${this.filters.bookmaker}`
        : ''
      const country = Object.prototype.hasOwnProperty.call(this.filters, 'country')
        ? `&country=${this.filters.country}`
        : ''
      const device = Object.prototype.hasOwnProperty.call(this.filters, 'device')
        ? `&device=${this.filters.device}`
        : ''
      const size = Object.prototype.hasOwnProperty.call(this.filters, 'size')
        ? `&size=${this.filters.size}`
        : ''
      const campaign = Object.prototype.hasOwnProperty.call(this.filters, 'campaign')
        ? `&campaign=${this.filters.campaign}`
        : ''
      const page = Object.prototype.hasOwnProperty.call(this.paginator, 'current_page')
        ? `&page=${this.paginator.current_page}`
        : ''
      const id = Object.prototype.hasOwnProperty.call(this.filters, 'id')
        ? `&id=${this.filters.id}`
        : ''
      return `${this.api_url}/banners?${bookmaker}${country}${device}${size}${campaign}${page}${id}`
    },
    checkIfBannerIsMarked (banner) {
      if (JSON.parse(banner.html).data.indexOf('Smile') !== -1) {
        return '<span style="font-size: 2em; color: Tomato;" ><i class="fa fa-smile"></i></span>'
      }
      return '<span style="font-size: 2em; color: Dodgerblue;"><i class="fa fa-frown"></i></span>'
    },
    getBannersTimeout () {
      this.$router.push({ query: this.filters })
      const filteredBannerTimeout = setTimeout(() => {
        this.getBanners()
        clearTimeout(filteredBannerTimeout)
      }, this.timeout)
    },
    markHtmlCode (banner) {
      if (JSON.parse(banner.html).data.indexOf('Smile') === -1) {
        this.$http.post(`${this.api_url}/banner/markcode/${banner._id}`, { mark: this.mark }).then((success) => {
          this.getBanners()
        })
      }
    },
    getBookmakers () {
      this.$http.get(`${this.api_url}/bookmakers/all`).then(bookmakers => {
        this.bookmakers = bookmakers.data
      })
    },
    getBannerSizes () {
      this.$http.get(`${this.api_url}/sizes/all`).then(sizes => {
        this.sizes = sizes.data
      })
    },
    getCampaigns () {
      this.$http.get(`${this.api_url}/campaigns/all`).then(campaigns => {
        this.campaigns = campaigns.data
      })
    },
    parseJson (banner) {
      let htData = JSON.parse(banner.html).data

      htData = htData.replace(/:backgroundUrl/g, `/uploads/${banner.image}`)

      htData = htData.replace(/:logoBanner/g, `/img/${banner.bookmaker}.png`)

      htData = htData.replace(
        /:bannerUrl/g,
          `${banner.bannerurl}:affiliateCode`
      )

      htData = htData.replace(/:affiliateCode/g, '222222')

      htData = htData.replace(/:countryCode/g, banner.country_code)

      htData = htData.replace(/:device/g, banner.device)

      htData = htData.replace(/:uniqueId/g, banner._id)

      return htData
    },
    generateUrl (banner) {
      let splittedSize = ''
      banner.size.split('').forEach((char, iteration) => {
        splittedSize +=
          iteration === banner.size.split('').length - 1
            ? `${char}`
            : `${char}_`
      })
      let url = `${this.$api_url.replace('/api', '')}/${banner.bookmaker}/325_200/${banner.country_code}/${banner.device}/${splittedSize}/${this.apiKey}`
      url += banner.campaign ? `?campaign=${banner.campaign}` : ''
      return url
    },
    searchById () {
      if (this.search) {
        this.filters.id = this.search
      } else {
        delete this.filters.id
      }
      this.getBannersTimeout()
    },
    bannerWidth (banner) {
      return banner.size.split('x')[0]
    },
    bannerHeight (banner) {
      return banner.size.split('x')[1]
    },
    filterReset () {
      this.country = 0
      this.size = 0
      this.device = 0
      this.campaign = 0
      this.bookmaker = 0
      this.paginator.current_page = 1
      this.filters = {}
      this.search = ''
      this.$router.push('/banners/manage')
      this.getBanners()
    },
    filterBySize () {
      this.paginator.current_page = 1
      if (this.size !== 0) {
        this.filters.size = this.size
      } else {
        delete this.filters.size
      }
      this.getBannersTimeout()
    },
    filterByDevice () {
      this.paginator.current_page = 1
      if (this.device !== 0) {
        this.filters.device = this.device
      } else {
        delete this.filters.device
      }
      this.getBannersTimeout()
    },
    filterByCountry () {
      this.paginator.current_page = 1
      if (this.country !== 0) {
        this.filters.country = this.country
      } else {
        delete this.filters.country
      }
      this.getBannersTimeout()
    },
    filterByCampaign () {
      this.paginator.current_page = 1
      if (this.campaign !== 0) {
        this.filters.campaign = this.campaign
      } else {
        delete this.filters.campaign
      }
      this.getBannersTimeout()
    },
    filterByBookmaker () {
      this.paginator.current_page = 1
      if (this.bookmaker !== 0) {
        this.filters.bookmaker = this.bookmaker
      } else {
        delete this.filters.bookmaker
      }
      this.getBannersTimeout()
    },

    initWithQueryParams () {
      if (this.$route.query.country) {
        this.country = this.$route.query.country
        this.filters.country = this.$route.query.country
      }
      if (this.$route.query.size) {
        this.size = this.$route.query.size
        this.filters.size = this.$route.query.size
      }
      if (this.$route.query.device) {
        this.device = this.$route.query.device
        this.filters.device = this.$route.query.device
      }
      if (this.$route.query.campaign) {
        this.campaign = this.$route.query.campaign
        this.filters.campaign = this.$route.query.campaign
      }
      if (this.$route.query.bookmaker) {
        this.bookmaker = this.$route.query.bookmaker
        this.filters.bookmaker = this.$route.query.bookmaker
      }
      if (this.$route.query.page) {
        this.paginator.current_page = this.$route.query.page
      }
      if (this.$route.query.id) {
        this.filters.id = this.$route.query.id
      }
    }
  },

  computed: {
    ...mapGetters(['countries', 'apiKey', 'permission']),
    from () {
      return parseInt(this.paginator.current_page) !== 1
        ? (parseInt(this.paginator.current_page) - 1) *
            parseInt(this.paginator.per_page) +
            1
        : 1
    },
    to () {
      const to =
        this.paginator.current_page !== 1
          ? (parseInt(this.paginator.current_page) - 1) *
              parseInt(this.paginator.per_page) +
            parseInt(this.paginator.per_page)
          : parseInt(this.paginator.per_page)
      return parseInt(this.paginator.filtered_total) <= to
        ? parseInt(this.paginator.filtered_total)
        : to
    }
  },
  created () {
    this.api_url = this.$api_url
    this.initWithQueryParams()
    this.getBanners()
    this.getBookmakers()
    this.getBannerSizes()
    this.getCampaigns()
    this.slugUrl = `${this.$api_url}/banner/verifySlugs/${this.apiKey}`
  }
}
</script>
